import type { AdminWorkspace } from "../modules/types";
import { adminApiGet } from "./utils";

export const adminWorkspacesApi = {
  getAll: (): Promise<AdminWorkspace[]> =>
    adminApiGet<AdminWorkspace[]>("/workspaces"),

  getById: (id: string): Promise<AdminWorkspace> =>
    adminApiGet<AdminWorkspace>(`/workspaces/${id}`),
};
